import { render, staticRenderFns } from "./ProjectHome.vue?vue&type=template&id=6b10f29a"
import script from "./ProjectHome.vue?vue&type=script&lang=js"
export * from "./ProjectHome.vue?vue&type=script&lang=js"
import style0 from "./ProjectHome.vue?vue&type=style&index=0&id=6b10f29a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports